module.exports = __webpack_public_path__ + "media/images/bg-leaderboard-card-header-164168eddd21e1846078a0da8a9a9808.webp";